/**
 * Idle-gated ambient snow — a config of the shared falling-particle effect.
 * Soft cold blue-white circles that read on both light and dark backgrounds.
 */
import { createFallingEffect } from './createFallingEffect';

/** Full-screen idle snow effect. Renders nothing until the user is idle. */
export const SnowOverlay = createFallingEffect({
  testId: 'snow-overlay',
  config: {
    count: 90,
    size: [1, 3.2],
    speed: [0.4, 1.6],
    drift: [-0.5, 0.5],
    alpha: [0.4, 0.9],
  },
  fill: 'rgb(195, 210, 235)',
  draw: (ctx, size) => {
    ctx.beginPath();
    ctx.arc(0, 0, size, 0, Math.PI * 2);
    ctx.fill();
  },
});
